import React from 'react';
import { View } from 'react-native';

import themeStyle from '../../../Theme/styles';
import ReservationCard from '../../Reservation/components/Card';

const ReservationItem = (props) => {
  return (
    <View style={themeStyle.pageHorizontalSpacing}>
      <ReservationCard {...props} />
    </View>
  );
};

export default ReservationItem;
